import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { graphqlRestClient } from '../bk-web-app';
import LastYEFDate from './lastYEFDate';
import LastCompletedYEFYear from './lastCompletedYEFYear';

const YearEndFinancialDate = (props: { clientId: string }) => {
  const { clientId } = props;
  return (
    <ApolloProvider client={graphqlRestClient}>
      <LastYEFDate clientId={clientId} />
      <LastCompletedYEFYear clientId={clientId} />
    </ApolloProvider>
  );
};

export default YearEndFinancialDate;
